module.exports = __webpack_public_path__ + "static/img/kjfw_1.fb6049a7.png";